// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__2Anpx","tab":"ProcedureTabs_tab__3HJfA"};